var map = {
	".": "LN1l",
	"./": "LN1l",
	"./GraphQLLanguageService": "CfMl",
	"./GraphQLLanguageService.js": "CfMl",
	"./autocompleteUtils": "WmlL",
	"./autocompleteUtils.js": "WmlL",
	"./getAutocompleteSuggestions": "reK8",
	"./getAutocompleteSuggestions.js": "reK8",
	"./getDefinition": "I7JT",
	"./getDefinition.js": "I7JT",
	"./getDiagnostics": "07Hx",
	"./getDiagnostics.js": "07Hx",
	"./getHoverInformation": "dp2Y",
	"./getHoverInformation.js": "dp2Y",
	"./getOutline": "w8mm",
	"./getOutline.js": "w8mm",
	"./index": "LN1l",
	"./index.js": "LN1l"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Metw";